import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, SectionHead } from "./Reveal";
import { scrollToId } from "../lib/scroll";

const IMGS = [
  "/uploads/p11.jpg",
  "/uploads/p08.jpg",
  "/uploads/p20.jpg",
  "/uploads/p17.jpg",
];

export const WhatWeDo = () => {
  const { t } = useLang();
  return (
    <section id="what-we-do" data-testid="what-section" className="mx-auto max-w-[1500px] px-5 py-24 md:px-10 md:py-32">
      <SectionHead num={t.what.num} title={t.what.title} sub={t.what.sub} testid="what-head" />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {t.what.items.map((item, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <button
              data-testid={`what-card-${i}`}
              onClick={() => scrollToId("#services")}
              className="group relative block w-full overflow-hidden border border-white/10 bg-[#0A0A0A] text-left transition-colors duration-500 hover:border-[#FF5A00]/60"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={IMGS[i]}
                  alt={item.t}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/30 transition-opacity duration-500 group-hover:opacity-10" />
              </div>
              <div className="p-6">
                <span className="num-outline font-display text-3xl">0{i + 1}</span>
                <h3 className="mt-3 font-display text-2xl uppercase tracking-wide">{item.t}</h3>
                <p className="mt-2 text-sm text-neutral-400">{item.d}</p>
                <span className="mt-5 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#FF5A00]">
                  {t.what.more}
                  <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
                </span>
              </div>
            </button>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
